export const accountChecklist = [
  'accountLoaded',
  'allUsersLoaded',
]

export const allScreeningsChecklist = [
  'allScreeningsLoaded',
  'accountLoaded',
  'allUsersLoaded',
  'currentUserLoaded',
]

export const singleScreeningChecklist = [
  'accountLoaded',
  'allUsersLoaded',
  'currentScreeningLoaded',
  'relatedScreeningsLoaded',
  'currentScreeningMetaDataLoaded',
  'currentScreeningTypesLoaded',
  'currentScreeningInterConnectionsLoaded',
  'currentScreeningSamplesLoaded',
  'currentScreeningBuildingsLoaded',
  'currentScreeningUnitsLoaded',
  'currentScreeningPCBScreeningLoaded',
  'addressImagesLoaded',
  'currentScreeningTestResultsLoaded',
  'currentScreeningWasteItemsLoaded',
]
